// eslint-disable-next-line @eslint-community/eslint-comments/disable-enable-pair
/* eslint-disable camelcase */

'use client';

import classnames from 'classnames/bind';
import { useCallback } from 'react';
import { BrowserLink } from '@/_kit/browser-link';
import { ProWbLogoIcon } from '@/_kit/icons/pro-wb-icon';
import { useWindowSize } from '@/_hooks/use-window-size';
import { isMobile } from '@/_utils/is-mobile';
import { EAnalytics } from '@/_constants/analytics';
import { useAnalytics } from '@/_hooks/use-analytics';
import { EEducationProgram, ELinkId } from '@/_components/education/_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'ProWbLink';

type TProps = {
  logoLink: string;
};

export const ProWbLink = ({ logoLink }: TProps) => {
  const sendEvent = useAnalytics();
  const { width } = useWindowSize();
  const isMobileWidth = isMobile(width);

  const handleClick = useCallback(() => {
    const config = {
      name: EAnalytics.SUPPLIER_LANDING_PRO_WB_FARVATER_BANNER_T,
      params: {
        link_name: ELinkId.PRO_WB,
        button_name: EEducationProgram.PRO_WB,
      },
    };

    sendEvent(config);
  }, [sendEvent]);

  if (isMobileWidth) {
    return null;
  }

  return (
    <div className={cn(BLOCK_NAME)}>
      <BrowserLink
        onClick={handleClick}
        rel="noopener noreferrer"
        rightIcon={ProWbLogoIcon}
        routeName={logoLink}
        target="_blank"
        isResolveUrl={false}
      />
    </div>
  );
};
